const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全加密访问',
    desc: '所有黑料子品牌入口采用安全加密传输，确保浏览隐私与数据安全，让你放心访问51黑料、91黑料等平台。',
    color: 'primary' as const,
  },
  {
    icon: 'ri-rocket-line',
    title: '实时更新同步',
    desc: '黑料入口地址每日更新维护，第一时间同步51黑料最新、17黑料地址等变化，保证始终可访问。',
    color: 'accent' as const,
  },
  {
    icon: 'ri-stack-line',
    title: '全品牌覆盖',
    desc: '一站式聚合51黑料网、91黑料网、17黑料网、718黑料等全部数字黑料子品牌，无需反复搜索。',
    color: 'primary' as const,
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速直达',
    desc: '优化访问路径，点击即可跳转至对应黑料平台，减少中间环节，提升浏览效率与体验。',
    color: 'secondary' as const,
  },
  {
    icon: 'ri-medal-line',
    title: '内容甄选推荐',
    desc: '基于热度与质量双重筛选机制，每日推荐黑料精华内容，帮你快速发现最值得关注的吃瓜与讨论。',
    color: 'accent' as const,
  },
];

const iconBg: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">平台优势</h2>
          <p className="mt-2 text-sm text-foreground-600">为什么选择黑料作为你的数字内容入口</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feat, idx) => (
            <div key={idx} className="text-center p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/30 transition-all cursor-pointer">
              <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${iconBg[feat.color]}`}>
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-sm font-bold font-heading text-foreground-900">{feat.title}</h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}